import EditOrderForm from '../../../Components/Order/EditOrderForm';

const EditOrder = () => {
  return (
    <div>
      <EditOrderForm />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default EditOrder;
